import React, { useState } from 'react';
import SayimAdresSecimi from '../../../components/sayim/terminal/SayimAdresSecimi';
import SayimNoGiris from '../../../components/sayim/terminal/SayimNoGiris';
import SayimOkutmaEkrani from '../../../components/sayim/terminal/SayimOkutmaEkrani';

const SayimTerminal = () => {
    // Basit state yönetimi
    const [currentScreen, setCurrentScreen] = useState('countInput');
    const [selectedCount, setSelectedCount] = useState(null);
    const [selectedZone, setSelectedZone] = useState(null);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Sayım numarası girişi
    const handleCountInput = async (count) => {
        try {
            setSelectedCount(count);

            // Her durumda zone seçim ekranına geç
            setCurrentScreen('zoneSelect');
        } catch (err) {
            setError('Sayım bilgisi alınamadı');
        }
    };

    // Zone ve adres seçimi
    const handleZoneAndAddressSelect = (zone, address) => {
        setSelectedZone(zone);
        setSelectedAddress(address);
        setCurrentScreen('okutmaEkrani');
    };



    return (
        <>
            {error && (
                <div className="alert alert-danger" role="alert">
                    {error}
                </div>
            )}

            {/* Sayım No Giriş Ekranı */}
            {currentScreen === 'countInput' && (
                <SayimNoGiris
                    onCountSelect={handleCountInput}
                    loading={loading}
                    setLoading={setLoading}
                />
            )}

            {/* Adres Seçim Ekranı - Her durumda göster */}
            {currentScreen === 'zoneSelect' && (
                <SayimAdresSecimi
                    selectedCount={selectedCount}
                    selectedZone={selectedZone}
                    loading={loading}
                    setLoading={setLoading}
                    setCurrentScreen={setCurrentScreen}
                    onZoneAndAddressSelect={handleZoneAndAddressSelect}
                />
            )}

            {/* Okutma Ekranı */}
            {currentScreen === 'okutmaEkrani' && (
                <SayimOkutmaEkrani
                    setCurrentScreen={setCurrentScreen}
                    selectedCount={selectedCount}
                    selectedZone={selectedZone}
                    selectedAddress={selectedAddress}
                />
            )}
        </>
    );
};

export default SayimTerminal;
